import React from "react";

type Props = {
  classes: {
    index: string;
    name: string;
    url: string;
  }[];
};

const Classes = ({ classes }: Props) => {
  return (
    <div className="mt-4">
      <h3 className="text-xl font-semibold mb-2">Classes:</h3>
      <div className="bg-white shadow-md rounded-lg p-4">
        <ul>
          {classes.map((c, index) => (
            <li key={index}>
              {c.name} ({c.index})
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Classes;
